
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shivsway",
      function () {
        return require("private-next-pages/shivsway.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shivsway"])
      });
    }
  